import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { useState, type PropsWithChildren } from "react";

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 30_000,
          },
        },
      }),
  );

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#164bff",
          colorInfo: "#164bff",
          colorSuccess: "#16845b",
          colorWarning: "#c77812",
          colorText: "#18213a",
          colorTextSecondary: "#68728f",
          colorBgLayout: "#f4f7fd",
          borderRadius: 10,
          fontFamily: '"Noto Sans SC", "Source Han Sans SC", "PingFang SC", sans-serif',
        },
        components: {
          Button: { controlHeight: 40, fontWeight: 600 },
          Card: { borderRadiusLG: 16 },
          Menu: { itemBorderRadius: 8 },
        },
      }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}
